import { useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Box,
  Grid,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  IconButton,
  Snackbar,
  CircularProgress,
  Hidden,
} from '@mui/material'
import Alert from '@mui/material/Alert'
import I18n from 'i18n-js'
import {
  Icons,
  languages,
  actionKeys,
  pagesKeys,
  rowsPerPage,
} from '../../utils'
import SearchBar from '../../components/searchBar'
import ModalForm from '../../components/modalForm'
import typeMedicalCenter from '../../services/typeMedicalCenter'
import CrudsBtn from '../../components/crudsBtn'
import LanguageSelector from '../../components/languageSelector'
import { AuthContext } from '../../context/auth'
import { canAccess } from '../../router/permissions'
import useStyles from '../crudsStyles'
import { handleError } from '../typeStaff/errors'
import { numbersAndCharacters } from '../../validators/validator'
import { AlertMenu } from '../../components'
const TypeMedicalCenter = () => {
  //state
  const { state } = useContext(AuthContext)
  const history = useHistory()
  //permissions
  const pageId = pagesKeys.typecenter
  //list
  const [inputs, setInputs] = useState([])
  const [body, setBody] = useState({})
  const [errors, setErrors] = useState({})

  const [data, setData] = useState([])
  const [items, setItems] = useState([])
  const [page, setPage] = useState(0)
  const [search, setSearch] = useState('')
  const [languageColOne, setLanguageColOne] = useState(languages[0].locale)
  const [languageColTwo, setLenguageColTwo] = useState(languages[1].locale)
  //create
  const [showAlert, setShowAlert] = useState(false)
  //edit
  const [editId, setEditId] = useState()
  //delete
  const [anchor, setAnchor] = useState(null)
  const [deleteItem, setDeleteItem] = useState()
  const [successDelete, setSuccessDelete] = useState(false)
  //modal
  const [openModal, setOpenModal] = useState(false)
  const [create, setCreate] = useState(true)
  const [disabledButton, setDisableButton] = useState(false)

  //list
  const getData = async () => {
    const res = await typeMedicalCenter.list()
    setData(res.data?.medicalCenterTypes)
    setItems(res.data?.medicalCenterTypes)
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }
  useEffect(() => {
    if (!canAccess(actionKeys.view, pageId, state)) {
      history.push('/dashboard')
    } else {
      getData()
    }
  }, [])

  const handleChange = ({ target }) => {
    const { name, value } = target
    let newBody = { ...body }

    if (name === 'code') {
      if (!numbersAndCharacters(value) || value === '') {
        newBody = { ...body, [name]: value ?? '' }
      }
    } else {
      newBody = { ...body, [name]: value ?? '' }
    }
    const error = handleError({
      [name]: value ?? '',
    })

    setBody(newBody)
    setDisableButton(languages.some((lang) => !newBody[lang.locale]))
    setErrors({
      ...errors,
      [name]: error[name] ?? '',
    })
  }

  const handleChangeSearchbar = (e) => {
    setSearch(e.target.value)
  }
  const searchItems = () => {
    if (search.trim() != '') {
      const filter = data?.filter((e) => {
        if (e?.translations?.length > 0) {
          if (
            e?.translations
              ?.find((lang) => lang?.locale == languageColOne)
              ?.description?.toLowerCase()
              ?.includes(search?.toLowerCase()) ||
            e?.translations
              ?.find((lang) => lang?.locale == languageColTwo)
              ?.description?.toLowerCase()
              ?.includes(search?.toLowerCase())
          ) {
            return e
          }
        }
      })
      filter != ''
        ? setItems(filter)
        : setItems([{ error: I18n.t('general.notFound') }])
    } else {
      setItems(data)
    }
    setPage(0)
  }

  useEffect(searchItems, [search])
  const handleChangeLenguaje1 = (e) => {
    setLanguageColOne(e.target.value)
  }
  const handleChangeLenguaje2 = (e) => {
    setLenguageColTwo(e.target.value)
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    let data = {
      description: languages.map((lang) => ({
        locale: lang.locale,
        value: body[lang.locale],
      })),
    }

    let response

    data.code = body.code ?? ''

    setDisableButton(true)
    if (create) {
      response = await typeMedicalCenter.create(data)
    } else {
      response = await typeMedicalCenter.edit({
        id: editId,
        update: data,
      })
    }
    if (response.data) {
      setOpenModal(false)
      getData()
      setSearch('')
      document.getElementById('search').value = ''
      setShowAlert(true)
    } else {
      setDisableButton(false)
    }
  }
  //delete
  const handleDeleteClick = (e) => {
    setAnchor(e.currentTarget)
  }
  const handleDeleteClose = () => {
    setAnchor(null)
  }
  const handleDeleteItem = async () => {
    await typeMedicalCenter.destroy(deleteItem)
    setAnchor(null)
    getData()
    setSearch('')
    document.getElementById('search').value = ''
    setShowAlert(true)
    setSuccessDelete(true)
  }
  //modal
  const openModalForm = (e, data = null) => {
    if (data) {
      const oldValues = {
        code: data.code,
      }

      data?.translations?.forEach((lang) => {
        oldValues[lang.locale] = lang.description
      })

      let objectLocale = { ...oldValues }

      delete objectLocale.code

      const error = { ...handleError(objectLocale) }

      setErrors(error)
      setDisableButton(Object.values(error ?? {}).length)
      setEditId(data.id)
      setBody(oldValues)
      setCreate(false)
    } else {
      setDisableButton(true)
      setBody({})
      setCreate(true)
    }
    setOpenModal(true)
  }

  const closeModal = () => {
    setOpenModal(false)
    setBody({})
    setErrors({})
  }

  useEffect(() => {
    let inputModel = [
      ...languages.map((lang) => ({
        name: lang.locale,
        label: `${I18n.t('general.name')} *`,
        InputProps: {
          startAdornment: Icons(lang.locale, true),
        },
        style: classes.inputWidth,
        rB: true,
      })),
      {
        name: 'code',
        label: I18n.t('cruds.typeStaff.code'),
        type: 'text',
        style: classes.inputWidth,
        inputProps: {maxLength: 100},
        rB: true,
      },
    ]

    setInputs(inputModel)
  }, [])

  const classes = useStyles()
  return (
    <Box p={4} m={4}>
      <Grid
        container
        spacing={2}
        direction="column"
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        wrap="nowrap"
      >
        <Grid item className={classes.items}>
          <Typography variant="body2" color="textSecondary">
            {I18n.t('breadcrumb.typeMedicalCenter')} /
            {I18n.t('breadcrumb.dashboard')}
          </Typography>
        </Grid>
        <Grid item className={classes.itemFlex}>
          <Typography
            variant="h5"
            color="primary"
            className={classes.title}
          >
            {I18n.t('breadcrumb.typeMedicalCenter')}
          </Typography>
          {canAccess(actionKeys.list, pageId, state) && (
            <Hidden smDown>
              <div className={classes.search}>
                <SearchBar
                  change={handleChangeSearchbar}
                  search={searchItems}
                />
              </div>
            </Hidden>
          )}

          {canAccess(actionKeys.create, pageId, state) && (
            <CrudsBtn
              text={I18n.t('cruds.typeCenter.button')}
              size="medium"
              click={openModalForm}
            />
          )}
        </Grid>
        {canAccess(actionKeys.list, pageId, state) && (
          <Hidden mdUp>
            <Grid item className={classes.items}>
              <SearchBar change={handleChangeSearchbar} search={searchItems} />
            </Grid>
          </Hidden>
        )}
        {canAccess(actionKeys.list, pageId, state) && (
          <Grid item className={classes.items}>
            <TableContainer className={classes.tableContainer}>
              <Table className={classes.table} size="small">
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell align="left" className={classes.tableCell}>
                      <LanguageSelector
                        change={handleChangeLenguaje1}
                        language={languageColOne}
                        languages={languages}
                      />
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      <LanguageSelector
                        change={handleChangeLenguaje2}
                        language={languageColTwo}
                        languages={languages}
                      />
                    </TableCell>
                    {(canAccess(actionKeys.edit, pageId, state) ||
                      canAccess(actionKeys.delete, pageId, state)) && (
                      <TableCell align="center">
                        <Typography variant="body1" color="textPrimary">
                          {I18n.t('general.actions')}
                        </Typography>
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                {items != '' && (
                  <TableBody>
                    {(rowsPerPage.typeCenter > 0
                      ? items?.slice(
                          page * rowsPerPage.typeCenter,
                          page * rowsPerPage.typeCenter + rowsPerPage.typeCenter
                        )
                      : items
                    )?.map((item, index) => {
                      const { translations } = item
                      if (item.error) {
                        return (
                          <TableRow className={classes.tableRow} key={index}>
                            <TableCell align="left" colSpan={4}>
                              <Typography variant="h6" color="primary">
                                {item.error}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )
                      } else {
                        return (
                          !item.error && (
                            <TableRow className={classes.tableRow} key={index}>
                              <TableCell className={classes.tableCell}>
                                {
                                  translations.find(
                                    (lang) => lang.locale == languageColOne
                                  )?.description
                                }
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                {
                                  translations.find(
                                    (lang) => lang.locale == languageColTwo
                                  )?.description
                                }
                              </TableCell>
                              {(canAccess(actionKeys.edit, pageId, state) ||
                                canAccess(
                                  actionKeys.delete,
                                  pageId,
                                  state
                                )) && (
                                <TableCell
                                  align="right"
                                  className={classes.tableCellActions}
                                >
                                  <div className={classes.divactions}>
                                    {canAccess(
                                      actionKeys.edit,
                                      pageId,
                                      state
                                    ) && (
                                      <IconButton
                                        color="secondary"
                                        onClick={(e) => {
                                          openModalForm(e, item)
                                        }}
                                      >
                                        {Icons('edit')}
                                      </IconButton>
                                    )}

                                    {canAccess(
                                      actionKeys.delete,
                                      pageId,
                                      state
                                    ) && (
                                      <IconButton
                                        className={classes.delete}
                                        onClick={(e) => {
                                          handleDeleteClick(e)
                                          setDeleteItem(item.id)
                                        }}
                                      >
                                        {Icons('delete')}
                                      </IconButton>
                                    )}
                                  </div>
                                </TableCell>
                              )}
                            </TableRow>
                          )
                        )
                      }
                    })}
                    <tr>
                      <TablePagination
                        rowsPerPageOptions={[rowsPerPage.typeCenter]}
                        count={items && items?.length}
                        page={page}
                        rowsPerPage={rowsPerPage.typeCenter}
                        onPageChange={handleChangePage}
                        className={classes.pagination}
                      />
                    </tr>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Grid>
        )}
      </Grid>
      <ModalForm
        open={openModal}
        close={closeModal}
        disabled={disabledButton}
        values={body}
        errors={errors}
        change={handleChange}
        submit={handleSubmit}
        tittle={
          create
            ? I18n.t('components.createItem')
            : I18n.t('components.editItem')
        }
        type={2}
        inputs={inputs}
        btnLabel={create}
      />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={showAlert}
        autoHideDuration={2000}
        onClose={() => {
          setShowAlert(false)
          setSuccessDelete(false)
        }}
        className={classes.alert}
      >
        <Alert severity="success">
          {successDelete
            ? I18n.t('components.alertDelete')
            : I18n.t('components.alert')}
        </Alert>
      </Snackbar>
      
      <AlertMenu
        anchor={anchor}
        close={handleDeleteClose}
        action={handleDeleteItem}
      />
      {items == '' && (
        <div className={classes.loadingBg}>
          <CircularProgress color="primary" className={classes.loading} />{' '}
        </div>
      )}
    </Box>
  )
}

export default TypeMedicalCenter
